const state = {
  current_report_mailbox: {}
}

const getters = {
  currentReportMailbox (state) {
    return state.current_report_mailbox
  }
}

const mutations = {
  setCurrentReportMailbox (state, mailbox) {
    state.current_report_mailbox = mailbox
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/current_report_mailbox.js